import React, { useEffect,useState,useContext } from "react";
import cancelarSolicitudRepresentacionService from '../../../services/cancelarSolicitudRepresentacionService'
import responderSolicitudRepresentacionService from '../../../services/responderSolicitudRepresentacionService'
import solicitudRepresentacionByIdService from '../../../services/solicitudRepresentacionByIdService'

import { withStyles, makeStyles } from '@material-ui/core/styles';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@material-ui/core';
import Spinner from '../../Spinner/Spinner'

import { useAlert } from 'react-alert'
import { AppContext } from '../../../App'
import { useAuth } from "react-oidc-context"

import { useConfirm } from 'material-ui-confirm';

import CheckIcon from '@material-ui/icons/Check';
import CancelIcon from '@material-ui/icons/Cancel';


const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
  }))(TableCell);
  
  const StyledTableRow = withStyles((theme) => ({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);

  
  const useStyles = makeStyles((theme) => ({
    table: {
      //minWidth: 700,
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    button: {
      margin: theme.spacing(1),      
    },
    buttonRed: {
      margin: theme.spacing(1),
      backgroundColor: '#f44336',
      "&:hover, &:focus": {
        backgroundColor: '#f54336',
        transition: '0.7s',
      },
      "&:active": {
        backgroundColor: '#f74336',
      }
    },
    buttonGreen: {
      margin: theme.spacing(1),
      backgroundColor: '#4CAF50',
      "&:hover, &:focus": {
        backgroundColor: '#4CBF50',
        transition: '0.7s',
      },
      "&:active": {
        backgroundColor: '#4CCF50',
      }
    },    
    confirmDialogTitle: {
      fontSize: "17px",
    },    
  
  }));

function  SolicitudesRepresentacionPendientes(){

    const classes = useStyles();

    const [isLoading, setIsLoading] = useState(false)    

   

    const {state, dispatch} = useContext(AppContext)
    const idcorl=state.idCorrelacion
    const auth = useAuth();
    const token = auth.user?.access_token;

     //ALERT + DIÁLOGO
     const alertInfo = useAlert()
     const confirm = useConfirm();
     

    const opcionesDialogo = {
      title : 'Confirme su acción',
      titleProps: {
        className : classes.confirmDialogTitle,
      },               
      confirmationText: 'Sí',
      confirmationButtonProps: {
        variant : "contained",
        //color : "success",
        className : classes.buttonGreen,
        startIcon : <CheckIcon />},
      cancellationText: 'No',
      cancellationButtonProps: { 
        autoFocus: true, 
        variant : "contained",
        //color : "error",
        className : classes.buttonRed,
        startIcon : <CancelIcon /> },      
    };
    
    // *********


    const formateaFechaGuiones = (fechaText) => {
              
      var fechaFormateada = '';
      
      var fecha = new Date(fechaText);
      if (fecha != null && !isNaN(fecha.getTime()) && fecha instanceof Date){                
        var fechaSinGMT = new Date(fecha.toUTCString().split(' ').slice(0, 4).join (' '))
        const dia = fechaSinGMT.getDate().toString().padStart(2,'0');
        const mes = (fechaSinGMT.getMonth() + 1).toString().padStart(2,'0');
        const anyo = fechaSinGMT.getFullYear().toString();

        fechaFormateada = dia + '/' + mes + '/' + anyo;
      }
      
      return fechaFormateada;
    }


    function fechaCaducidadGuiones(fechaSolicitud, fechaVigencia){      
      var fechaSolicitudSinGMT = new Date(new Date(fechaSolicitud).toUTCString().split(' ').slice(0, 4).join (' '));      
      var fechaVigenciaSinGMT = new Date(new Date(fechaVigencia).toUTCString().split(' ').slice(0, 4).join (' '));
      var fechaCaducidadSinGMT = new Date(fechaSolicitudSinGMT.setMonth(fechaSolicitudSinGMT.getMonth()+1));       
                  
      if (fechaVigenciaSinGMT < fechaCaducidadSinGMT){
        var x = new Date(fechaVigenciaSinGMT.getFullYear(), fechaVigenciaSinGMT.getMonth(), fechaVigenciaSinGMT.getDate(), 23, 59, 59);
        return formateaFechaGuiones(x);
      }
      else{
        var x = new Date(fechaCaducidadSinGMT.getFullYear(), fechaCaducidadSinGMT.getMonth(), fechaCaducidadSinGMT.getDate(), 23, 59, 59);
        return formateaFechaGuiones(x);
      }               
    }

    function textoOtroIdentificacion(tipoSolicitudRepresentacion, rolDelUsuarioEnLaSolicitud, nifRepresentante, nombreRepresentante, nifRepresentado, nombreRepresentado)
    {
      var texto = '---';
      
      if (textoUsuarioEnCalidadDe(tipoSolicitudRepresentacion, rolDelUsuarioEnLaSolicitud) == "Mi Representado"){
        texto = nifRepresentado;
        if (EnCalidadDeReceptorSolicitud(rolDelUsuarioEnLaSolicitud)){
          texto += ' - ' + nombreRepresentado;
        }
      }
      else if (textoUsuarioEnCalidadDe(tipoSolicitudRepresentacion, rolDelUsuarioEnLaSolicitud) == "Mi Representante"){
        texto = nifRepresentante;
        if (EnCalidadDeReceptorSolicitud(rolDelUsuarioEnLaSolicitud)){
          texto += ' - ' + nombreRepresentante;
        }
      }

      return texto;      
    }

    function textoAlcanceRepresentacion(tipoRepresentacion){
      return 'Completa';
    }

    function textoUsuarioEnCalidadDe(tipoSolicitudRepresentacion, rolDelUsuarioEnLaSolicitud)
    {     
      if (SolicitudDeRepresentante(tipoSolicitudRepresentacion)) {
        if (EnCalidadDeEmisorSolicitud(rolDelUsuarioEnLaSolicitud)){
          return 'Mi Representado';
        }
        else if (EnCalidadDeReceptorSolicitud(rolDelUsuarioEnLaSolicitud)){
          return 'Mi Representante';
        }
      }          
      else if (SolicitudDeRepresentado(tipoSolicitudRepresentacion)) {
        if (EnCalidadDeEmisorSolicitud(rolDelUsuarioEnLaSolicitud)){
          return 'Mi Representante';
        }
        else if (EnCalidadDeReceptorSolicitud(rolDelUsuarioEnLaSolicitud)){
          return 'Mi Representado';
        }
      } 
      else
          return '---';      
    }

    function EnCalidadDeEmisorSolicitud(rolDelUsuarioEnLaSolicitud){
      if ( rolDelUsuarioEnLaSolicitud == 1 ) 
        return true;      
      
      return false;
    }

    function EnCalidadDeReceptorSolicitud(rolDelUsuarioEnLaSolicitud){
      if ( rolDelUsuarioEnLaSolicitud == 2 ) 
        return true;      
      
      return false;
    }
    

    function SolicitudDeRepresentante(tipoSolicitudRepresentacion){
      if (tipoSolicitudRepresentacion == 1) 
        return true;
      return false;
    }

    function SolicitudDeRepresentado(tipoSolicitudRepresentacion){
      if (tipoSolicitudRepresentacion == 2) 
        return true;
      return false;
    }


    const updateListaSolicitudesPendientes = (newValue) => {
      dispatch({ type: 'UPDATE_SOLICITUDES_PENDIENTES_STATUS', data: newValue,});
    };

    const updateListaSolicitudesRespondidas = (newValue) => {
      dispatch({ type: 'UPDATE_SOLICITUDES_RESPONDIDAS_STATUS', data: newValue,});
    };

    const updateListaSolicitudesPendientesUI = (newValue) => {
      dispatch({ type: 'UPDATE_SOLICITUDES_PENDIENTES_UI_STATUS', data: newValue,});
    };

    const updateListaSolicitudesRespondidasUI = (newValue) => {
      dispatch({ type: 'UPDATE_SOLICITUDES_RESPONDIDAS_UI_STATUS', data: newValue,});
    };
    
    const updateListaSolicitudesBajas = (newValue) => {
      dispatch({ type: 'UPDATE_SOLICITUDES_BAJAS_STATUS', data: newValue,});
    };
    
    const updateListaSolicitudesBajasUI = (newValue) => {
      dispatch({ type: 'UPDATE_SOLICITUDES_BAJAS_UI_STATUS', data: newValue,});
    };

    /////

    function getSolicitudByIdAndAddToBajas(id){      
      setIsLoading(true)        
      solicitudRepresentacionByIdService({idSolicitud: id, idcorl, token})
      .then(datos => {          
          setIsLoading(false)
          
          if (datos.ok){            
            const newListBajas = state.arraySolicitudesRepresentacionBajas;    
            newListBajas.push(datos.respuesta);            
            updateListaSolicitudesBajas(newListBajas);
            
            //const newListBajasUI = state.arraySolicitudesRepresentacionBajasUI;    
            //newListBajasUI.push(datos.respuesta);            
            updateListaSolicitudesBajasUI(newListBajas);
            
          }
          else{
              alertInfo.error(<div>Error al consultar la Solicitud Cancelada. <br/><br/> {datos.mjeError} </div>, { timeout: 0 });  
          }
  
      }).catch((error) => {
          alert("Ha ocurrido un error. Por favor póngase en contacto con soporte (soportec@navarra.es) facilitando el identificador de correlación.");
          setIsLoading(false)          
      }) 
    }

    function handleAccionCancelar(id) {            
      var accion = "cancelar";       
      confirm({...opcionesDialogo, description : <div style={{fontSize: '17px'}}>¿Está seguro de querer {accion} su solicitud?</div>}) 
      .then(() => { 
        setIsLoading(true)        
        cancelarSolicitudRepresentacionService({idSolicitud: id, idcorl, token})
        .then(datos => {          
            setIsLoading(false)
            
            if (datos.ok){
              const newList = state.arraySolicitudesRepresentacionPendientes.filter((item) => item.idSolicitud !== id);    
              updateListaSolicitudesPendientes(newList);         

              const newListUI = state.arraySolicitudesRepresentacionPendientesUI.filter((item) => item.idSolicitud !== id);    
              updateListaSolicitudesPendientesUI(newListUI);         
              
              getSolicitudByIdAndAddToBajas(id);

              alertInfo.success("Solicitud de cancelación realizada con éxito.");                                     
            }
            else{
                alertInfo.error(<div>Solicitud NO enviada. <br/><br/> {datos.mjeError} </div>, { timeout: 0 });  
            }
    
        }).catch((error) => {
            alert("Ha ocurrido un error. Por favor póngase en contacto con soporte (soportec@navarra.es) facilitando el identificador de correlación.");
            setIsLoading(false)          
        })  
      })
      .catch(() => { alertInfo.error("Acción cancelada", { timeout: 0 }); });               
    }

    function mapeaResponderSolicitud(id, tipoAccion){      
      let datosResponderSolicitud = {        
          "idSolicitud" : parseInt(id),//'-1', //          
          "respuesta": parseInt(tipoAccion)          
      }
      return datosResponderSolicitud;
    }

    function textoAccionDialogo(tipoAccion){
      switch (tipoAccion) {        
        case 1:          
          return 'aceptar';
        case 2:          
          return 'rechazar';
        default:
          return '-';
      }
    }

    function textoInfoAccion(tipoAccion){
      switch (tipoAccion) {        
        case 1:          
          return "Solicitud aceptada con éxito.";
        case 2:          
          return "Solicitud rechazada con éxito.";
        default:
          return "-";
      }
    }

    const handleAccionAceptarRechazar = (id, tipoAccion) => {
      //Aceptar 1, Rechazar 2
      var accion = textoAccionDialogo(tipoAccion);

      confirm({...opcionesDialogo, description : <div style={{fontSize: '17px'}}>¿Está seguro de querer {accion} su solicitud?</div>}) 
      .then(() => { 
        setIsLoading(true)        
        responderSolicitudRepresentacionService({datosResponderSolicitud: mapeaResponderSolicitud(id, tipoAccion), idcorl, token})
        .then(datos => {          
            setIsLoading(false)
            
            if (datos.ok){
              const newList = state.arraySolicitudesRepresentacionPendientes.filter((item) => item.idSolicitud !== id);                  
              const newListUI = state.arraySolicitudesRepresentacionPendientesUI.filter((item) => item.idSolicitud !== id);    
              
              updateListaSolicitudesPendientes(newList);       
              updateListaSolicitudesPendientesUI(newListUI);      

              if (tipoAccion == 1){
                //Acepta
                const newListRespondidas = state.arraySolicitudesRepresentacionRespondidas;    
                newListRespondidas.push(datos.respuesta);                          
                const newListRespondidasUI = state.arraySolicitudesRepresentacionRespondidasUI;    
                newListRespondidasUI.push(datos.respuesta);            
                                 
                updateListaSolicitudesRespondidas(newListRespondidas);            
                updateListaSolicitudesRespondidasUI(newListRespondidasUI);    
              }
              else if (tipoAccion == 2){
                //Rechaza
                const newListBajas = state.arraySolicitudesRepresentacionBajas;    
                newListBajas.push(datos.respuesta);                          
                const newListBajasUI = state.arraySolicitudesRepresentacionBajasUI;    
                newListBajasUI.push(datos.respuesta);            
                                 
                updateListaSolicitudesBajas(newListBajas);            
                updateListaSolicitudesBajasUI(newListBajasUI);    
              }
  
                            
              alertInfo.success(textoInfoAccion(tipoAccion));                                     
            }
            else{
              alertInfo.error(<div>Solicitud NO enviada. <br/><br/> {datos.mjeError} </div>, { timeout: 0 });  
            }
    
        }).catch((error) => {
            alert("Ha ocurrido un error. Por favor póngase en contacto con soporte (soportec@navarra.es) facilitando el identificador de correlación.");
            setIsLoading(false)          
        }) 
      })
      .catch(() => { alertInfo.error("Acción cancelada", { timeout: 0 }); });
      
    }  

    function textoEstado(idEstado){
      switch (idEstado) {
        //case 0:          
        //  return 'Sin definir';
        case 1:          
          return 'Solicitada';
        case 2:          
          return 'Aceptada';
        case 3:          
          return 'Rechazada';
        case 4:          
          return 'Expirada';
        case 5:          
          return 'Cancelada';
        case 6:          
          return 'Revocada';
        case 7:
          return 'Caducada';
        case 8:
            return 'Anulada por baja en BD personas';
        case 9:
            return 'Anulada por inicio concurso';
        case 10:
              return 'Anulada por final de concurso';
        case 13:
              return 'Anulada por absorción';
        default:
          return '-';
      }
    }
    
    return (
        <>
            {isLoading && <div><strong>Actualizando...</strong><Spinner></Spinner></div>}

            {!isLoading && (!state.arraySolicitudesRepresentacionPendientes || state.arraySolicitudesRepresentacionPendientes.length <= 0) && 
                <div>
                  <strong>NO TIENE SOLICITUDES DE REPRESENTACIÓN PENDIENTES</strong>
                  <br/>                  
                </div>
            }

            {!isLoading && state.arraySolicitudesRepresentacionPendientes && state.arraySolicitudesRepresentacionPendientes.length > 0 &&             
              <div>
                <div><strong>Solicitudes de representación pendientes</strong></div>
                <div>                                                

                    <TableContainer component={Paper}>
                        <Table  className={classes.table} size="small" aria-label="customized table">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell align="center">Alcance representación</StyledTableCell>
                                    <StyledTableCell align="center">Identificación </StyledTableCell>                       
                                    <StyledTableCell align="center">En calidad de</StyledTableCell>
                                    <StyledTableCell align="center">Estado</StyledTableCell>
                                    <StyledTableCell align="center">Solicitud</StyledTableCell>
                                    <StyledTableCell align="center">Vigencia</StyledTableCell>
                                    <StyledTableCell align="center">Caducidad</StyledTableCell>
                                    <StyledTableCell align="center">Acciones</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {state.arraySolicitudesRepresentacionPendientesUI.map((row) => (
                                    <StyledTableRow  key={row.idSolicitud}>
                                        <StyledTableCell align="center">{textoAlcanceRepresentacion(row.tipoRepresentacion)}</StyledTableCell>
                                        <StyledTableCell align="center">{textoOtroIdentificacion(row.tipoSolicitudRepresentacion, row.rolDelUsuarioEnLaSolicitud, row.nifRepresentanteSolicitud, row.razonSocialRepresentanteSolicitud, row.nifRepresentadoSolicitud, row.razonSocialRepresentadoSolicitud)}</StyledTableCell>
                                        <StyledTableCell align="center">{textoUsuarioEnCalidadDe(row.tipoSolicitudRepresentacion, row.rolDelUsuarioEnLaSolicitud)}</StyledTableCell>
                                        <StyledTableCell align="center">{textoEstado(row.estadoActual)}</StyledTableCell>
                                       
                                        <StyledTableCell align="center">{formateaFechaGuiones(row.fechaSolicitud)}</StyledTableCell>
                                        <StyledTableCell align="center">{formateaFechaGuiones(row.vigencia)}</StyledTableCell>
                                        <StyledTableCell align="center">{fechaCaducidadGuiones(row.fechaSolicitud, row.vigencia)}</StyledTableCell>
                                        {EnCalidadDeEmisorSolicitud(row.rolDelUsuarioEnLaSolicitud) &&
                                          <>
                                          <StyledTableCell align="center"><button type="button" className="btn btn-success" onClick={() => handleAccionCancelar(row.idSolicitud)}>Cancelar</button></StyledTableCell>
                                          </>
                                        }
                                        {EnCalidadDeReceptorSolicitud(row.rolDelUsuarioEnLaSolicitud) &&
                                          <>
                                          <StyledTableCell align="center">
                                            <button type="button" className="btn btn-success" onClick={() => handleAccionAceptarRechazar(row.idSolicitud, 1)}>Aceptar</button>
                                            &nbsp;&nbsp;&nbsp;
                                            <button type="button" className="btn btn-success" onClick={() => handleAccionAceptarRechazar(row.idSolicitud, 2)}>Rechazar</button>
                                          </StyledTableCell>
                                          </>
                                        }                                        
                                    </StyledTableRow >
                                ))                                
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>                    
              </div>
            }
          
            
            

        </>
        )
}
export default SolicitudesRepresentacionPendientes
